import React from "react";
import HostAttendeeView from "./components/hostAttendeeView";


const AgoraStream = () => {
    return (
      // <div className="flex h-full w-full  items-center justify-center">
      <div className="flex h-full w-full " style={{backgroundColor: 'black'}}>
        <HostAttendeeView></HostAttendeeView>
      </div>
    );
  };
  
  export default AgoraStream;
  